import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * Provides i18n configuration for the application
 * 
 * Configuration:
 * - Default language: English ('en')
 * - Fallback language: English ('en')
 * - Translation files location: /assets/i18n/{lang}.json
 * 
 * Note: English translations require special handling in app.config.ts
 * because TranslateService may skip loading the default language file.
 */
export function provideI18n(): EnvironmentProviders {
  const httpLoaderProviders = provideTranslateHttpLoader({
    prefix: '/assets/i18n/',
    suffix: '.json',
  });
  
  // Ensure httpLoaderProviders is always an array
  const loaderProvidersArray = Array.isArray(httpLoaderProviders) 
    ? httpLoaderProviders 
    : (httpLoaderProviders ? [httpLoaderProviders] : []);
  
  return makeEnvironmentProviders([
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        fallbackLang: 'en',
        useDefaultLang: true,
      }),
    ),
    ...loaderProvidersArray,
  ]);
}


